<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyCharges"
  >

    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomInputPrimary
            v-model="simpleFilter.academia_url"
            :disabled="pagination.showLoadingState"
            v-on:keyup.enter="searchSimpleFilter"
            name="academiaUrl"
            placeholder="url de la academia"
            type="text"
            wrapperClass="a-input-wrapper-row"
        />
        <AtomSelectPrimary
          v-model.number="simpleFilter.typeSales"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.typesOfSale"
          keyField="id"
          name="typeSales"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />
        <AtomSelectCheckboxPrimary
          :elements="[...$filters.parameters.salesStates].filter(s => s.id !== 9)"
          :disabled="(simpleFilter.typeSales !== 9 ? Boolean(simpleFilter.typeSales) : true) || pagination.showLoadingState"
          v-model="simpleFilter.estado"
          name="estado"
          @onChange="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.buscar"
          :disabled="pagination.showLoadingState"
          name="email"
          placeholder="alumno@email.com"
          type="email"
          wrapperClass="a-input-wrapper-row"
          v-on:keyup.enter="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingAcademySalesDropDownFilters
          :academiaIdSeted="academia_id"
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <div class="display-flex-row margin-left-auto">
        <AtomButtonSecondary
          v-show=false
          :button-secondary="buttonSecondary.payments"
          @goToInvoicesHistory="goToInvoicesHistory"
        />
        <form
          autocomplete="off"
          class="m-form-row"
          name="download-csv-form"
          @submit.prevent="readVentasExportar"
        >
          <AtomButtonPrimary
            :button-primary="buttonPrimary"
            :disabled="pagination.showLoadingState || !ventas.length"
          />
        </form>
      </div>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="ventas.length">
          <th
            class="text-align-right"
            width="15%"
          >
            {{ $t('mEditionBillingAcademySales.table.thTotal') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionBillingAcademySales.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
            {{ $t('mEditionBillingAcademySales.table.thDatePayNext') }}
          </th>
          <th
            class="text-align-center"
            width="10%"
          >
             {{ $t('mEditionBillingAcademySales.table.thDiscount') }}
          </th>
          <th
            class="text-align-center"
            width="13%"
          >
             {{ $t('mEditionBillingAcademySales.table.thMethod') }}
          </th>
          <th
            class="text-align-left"
            width="14%"
          >
             {{ $t('mEditionBillingAcademySales.table.thConcept') }}
          </th>
          <th
            class="text-align-left"
            width="16%"
          >
             {{ $t('mEditionBillingAcademySales.table.thClient') }}
          </th>
          <th
            class="text-align-center"
            width="11%"
          >
             {{ $t('mEditionBillingAcademySales.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
             {{ $t('mEditionBillingAcademySales.table.thRecord') }}
          </th>
        </tr>
        <tr
          v-for="(venta, index) in ventas"
          :key="index"
          class="row-data"
        >
          <td class="text-align-right text-white-space-nowrap">
            <a
              v-if="venta.total || venta.precio"
              class="sale-state"
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${venta.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              target="_blank"
            >
              <span>{{ venta.divisa }} {{ venta.total.toFixed(2) }}</span>
              <span class="text-color-black-35"> {{ venta.divisa_iso_code }}</span><br>
              <small :class="$filters.getSaleStateValue(venta.venta_estado, 'class')">
                {{ $filters.getSaleStateValue(venta.venta_estado, 'name') }}
              </small>
            </a>
            <a
             v-else
              class="sale-state"
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${venta.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              target="_blank"
            >
              <span>{{ $t('mEditionBillingAcademySales.free') }}</span><br>
              <small :class="$filters.getSaleStateValue(venta.venta_estado, 'class')">
                {{ $filters.getSaleStateValue(venta.venta_estado, 'name') }}
              </small>
            </a>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(venta.fecha_venta).format('D MMM YYYY') }}
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            <span v-if="venta.fecha_proximo_pago">
              {{ $moment.parseZone(venta.fecha_proximo_pago).format('D MMM YYYY') }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="ellipsis text-align-center">
            <span
              v-if="venta.cupon_codigo"
              :key="`${index}-${venta.cupon_codigo}`"
            >
              {{ venta.cupon_codigo }}
            </span>
            <span
              v-else
              :key="`${index}-nodiscount`"
            >
              -
            </span>
          </td>
          <td class="text-align-center">
            <span v-if="venta.medio_pago">
              {{ venta.medio_pago }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="break-word text-align-left">
            {{ venta.concepto }}
          </td>
          <td class="break-word text-align-left">
            <span class="display-flex-column">
              <span>{{ venta.nombre_cliente }}</span>
              <small class="ellipsis font-weight-regular text-color-black-35">
                {{ venta.email_cliente }}
              </small>
            </span>
          </td>
          <td class="text-align-center">
            {{
              venta.total || venta.precio
                ? $utils.getPaymentFrequency(venta.pago_cuotas, venta.pago_frecuencia, venta.pago_intervalo)
                : '-'
            }}
          </td>
          <td class="text-align-center">
            <a
              :href="`${$t('mEditionMenu.billing.academySales.subject')}/${venta.id_venta}/${$t('mEditionMenu.billing.academySales.children.record.subedition')}`"
              class="a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded align-items-center justify-content-center"
              target="_blank"
            >
              <i class="far fa-file-alt"></i>
            </a>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import configApp from '@/config'
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionBillingAcademySales',

  components: {
    AtomSelectCheckboxPrimary: () => import('@/components/atoms/AtomSelectCheckboxPrimary'),
    MoleculeEditionBillingAcademySalesDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingAcademySalesDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      academia_id: '',

      buttonIconRounded: {
        record: {
          class: 'a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'gotToSaleRecord',
          tooltip: 'Ver Venta',
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionBillingAcademySales.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-primary a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        filter: {
          class: 'a-button-secondary a-button-billing-secondary',
          component: 'MoleculeEditionBillingAcademySalesDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingAcademySales.buttonSecondary.filterText'),
          type: 'button'
        },

        payments: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-file-alt',
          method: 'goToInvoicesHistory',
          text: '',
          tooltip: 'Ver Comprobantes',
          type: 'button'
        },

        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingAcademySales.tooltip.restart'),
          type: 'button'
        }
      },

      filter: {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        type_sales: '',
        type_product: ''
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      showLoadingState: true,

      simpleFilter: {
        academia_url: '',
        buscar: '',
        estado: [''],
        periodo: 0,
        typeSales: 0
      },

      ventas: []
    }
  },

  created () {
    // Verificar si viene una variable por GET, si no usar la configuración por defecto
    this.simpleFilter.academia_url = this.$route.query.academia_url || configApp.academyUrl

    // Si viene buscar por GET, asignarlo al filtro de búsqueda
    if (this.$route.query.buscar) {
      this.simpleFilter.buscar = this.$route.query.buscar
    }

    this.searchSimpleFilter()
  },

  methods: {
    getTotalVenta (total, monto, trial, cuotas) {
      if (!total && monto) {
        total = monto
      }
      return !cuotas
        ? total
        : (cuotas * monto) + trial
    },

    goToInvoicesHistory () {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.academySales.subject')}/${this.$t('mEditionMenu.billing.academySales.children.invoicesHistory.subedition')}`)
    },

    readAcademia () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaUrl', {}, [this.simpleFilter.academia_url])
          .then(response => {
            this.academia_id = response.data.id
            this.readVentas()
          })
          .catch(error => {
            this.showLoadingState = false
            this.pagination.showLoadingState = false
            this.$alerts.pushAlert('mEditionBillingAcademySales', 'readVentas', 'error', 'a-alert-danger')
            console.log(error)
          })
      }
    },

    readVentas () {
      this.$services.read('ventas', 'readVentasAcademia', {}, [this.academia_id], this.filter)
        .then(response => {
          this.ventas = []
          this.ventas = response.data.ventas
          this.pagination.currentQuantity = this.ventas.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.ventas = []
          this.pagination.currentQuantity = 0
          this.pagination.totalPages = 0
          this.pagination.totalQuantity = 0
          this.pagination.showLoadingState = false
          this.showLoadingState = false
        })
    },

    readVentasExportar () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('ventas', 'readVentasAcademiaExportar', {}, [this.academia_id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionBillingAcademySales.files.sales')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademySales', 'readVentasExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            this.$alerts.pushAlert('mEditionBillingAcademySales', 'readVentasExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.setSimpleFilter(this.simpleFilter.academia_url, '', 0, [''])
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        buscar: '',
        cupon: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        pasarela_pago: [],
        producto: [],
        type_sales: '',
        type_product: ''
      }
    },

    setSimpleFilter (academyUrl, alumno, tipoVenta, estado) {
      this.simpleFilter = {
        academia_url: academyUrl,
        buscar: alumno,
        estado: estado.length === 0 ? [''] : estado,
        periodo: 0,
        typeSales: tipoVenta
      }
    },

    searchAdvancedFilter (advancedFilter, academiaUrl) {
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.buscar) ||
        this.simpleFilter.buscar === '') {
        // Preserve advanced filter values before reset
        const preservedAdvancedFilters = {
          cupon: this.filter.cupon,
          divisa: [...this.filter.divisa],
          pais: this.filter.pais,
          pasarela_pago: [...this.filter.pasarela_pago],
          producto: [...this.filter.producto],
          type_product: this.filter.type_product
        }

        this.resetAdvancedFilter()

        // Restore preserved advanced filter values
        this.filter.cupon = preservedAdvancedFilters.cupon
        this.filter.divisa = preservedAdvancedFilters.divisa
        this.filter.pais = preservedAdvancedFilters.pais
        this.filter.pasarela_pago = preservedAdvancedFilters.pasarela_pago
        this.filter.producto = preservedAdvancedFilters.producto
        this.filter.type_product = preservedAdvancedFilters.type_product

        // Set simple filter values
        this.filter.buscar = this.simpleFilter.buscar

        if (this.simpleFilter.typeSales === '') {
          this.simpleFilter.typeSales = 0
        }

        this.filter.estado = this.simpleFilter.estado.filter((estado) => estado !== '')

        if (this.simpleFilter.periodo === '') {
          this.simpleFilter.periodo = 0
        }

        this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
        this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
        this.filter.type_sales = this.simpleFilter.typeSales
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademia()
    }
  }
}
</script>
